import { ArrowRight } from 'lucide-react';

export default function CallToAction() {
  return (
    <div className="py-24 bg-blue-50">
      <div className="max-w-4xl mx-auto px-4 sm:px-6 lg:px-8 text-center">
        <h2 className="text-4xl md:text-5xl font-bold text-gray-900 mb-6">
          Switch to smarter, more affordable AI solutions
        </h2>
        <p className="text-xl text-gray-600 mb-12">
          Visit NextAPI.org today and take your development to the next level!
        </p>
        <a href="https://api.nextapi.org" className="inline-flex items-center px-8 py-3 rounded-lg text-lg font-semibold text-white bg-blue-600 hover:bg-blue-700 transition-colors">
          Get Started <ArrowRight className="ml-2 h-5 w-5" />
        </a>
      </div>
    </div>
  );
}